import { createActionGroup, props } from '@ngrx/store';
import { CrewLogQuery, CrewLogResult } from '../../features/attendance-log/models';

/** Why an export did not produce a file: no rows matched, or the request failed. */
export type CrewLogExportFailure = 'empty' | 'error';

export const AttendanceLogActions = createActionGroup({
  source: 'Attendance Log',
  events: {
    'Load Crew Log': props<{ query: CrewLogQuery }>(),
    'Load Crew Log Success': props<{ result: CrewLogResult }>(),
    'Load Crew Log Failure': props<{ error: string }>(),
    'Export Crew Log': props<{ query: CrewLogQuery; fileName: string }>(),
    'Export Crew Log Success': props<{ blob: Blob; fileName: string }>(),
    'Export Crew Log Failure': props<{ reason: CrewLogExportFailure; message: string }>(),
  },
});
